module.exports = __webpack_public_path__ + "static/asmodeus_symbol_DND4_FRPG-61db49be52fb15a05ceb96420b395bfd.webp";